import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DataQuery} from '../data-query.model';
import {DataQueryService} from '../data-query.service';
import {SharedService} from '../../../shared-components/shared.service';

@Component({
	selector: 'app-delete-query-dialog',
	templateUrl: './delete-query-dialog.component.html',
	styleUrls: ['./delete-query-dialog.component.css']
})
export class DeleteQueryDialogComponent implements OnInit {

	// Injected Properties
	query: DataQuery;

	// Class Functions
	constructor(
		private dialogBox: MatDialogRef<DeleteQueryDialogComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dataQueryService: DataQueryService,
		private sharedService: SharedService
	) { }

	// Event Functions
	ngOnInit() {
		// PRE: injected data with the injected properties
		// POST: sets the injected properties
		this.query = this.data.query;
	}

	delete() {
		// PRE: the delete button is clicked
		// POST: deletes the query and closes the dialog box with true
		this.dataQueryService.deleteQuery(this.query,
			() => {
				this.dialogBox.close(true);
			},
			() => {
				this.sharedService.showBadSnackbar('Failed to delete query');
			}
		);
	}

	cancel() {
		// PRE: the cancel button is clicked
		// POST: closes the dialog box with false
		this.dialogBox.close(false);
	}

	// Methods

}
